<div class="stories theme-{{config?.theme}} {{config?.cause}}">
  <div class="heading">{{config?.title}}<em class="icon-kettobirds"></em></div>
  <div class="listing">
    <ngx-glide arrowLeftLabel="" arrowRightLabel="" [bound]="true"
            [showArrows]="!isMobile && config?.theme?.match('2') ? true : false"
            [showBullets]="(isMobile && config?.theme?.match('1')) || config?.theme?.match('2') ? true : false"
            [breakpoints]="breakpoints" >
      <div *ngFor="let item of config?.stories" class="card">
        <div *ngIf="!config?.theme" class="widget">
          <img class="story-image" [src]="item?.img" alt="story-image" />
          <div class="desc-container">
            <div class="description">
              <div class="text">{{item?.description}}</div> 
              <div class="title" [ngClass]="{'title1': config?.cause?.match('elderly|food_hunger')}"> {{item?.title}}
              <div class="sip-tag">SIP</div>
              <div *ngIf="config?.cause?.match('elderly|food_hunger')" class="ngo-tag">
                NGO
              </div>
            </div>
            </div>
          </div>
          <div class="raised-supporters">
            <div>
              <div class="raised">
                <app-currency-icon [currency]="config?.currency"></app-currency-icon>{{item?.raised | inrFormat:config?.currency}}
                <span>Raised</span>
              </div>
            </div>
            <div>
              <div class="supporters">{{item?.supporters}} <span>Supporters</span></div>
            </div>
          </div>
        </div>
        <div *ngIf="config?.theme?.match('1|2')" class="story">
          <div class="image">
            <img class="impact-logo" loading="lazy" data-src="/assets/images/sip-by-ketto.png" alt="sip" />
            <img class="story-image" loading="lazy" data-src="{{item?.img}}" alt="sip" />
            <div class="text-layer"><div class="text">{{item?.description}}</div></div>
          </div>
          <div class="desc">
            <div class="name">{{item?.name}}</div>
            <div class="disease">{{item?.disease}}</div>
          </div>
        </div>
      </div>
    </ngx-glide>
  </div>
</div>